import MerchOrderScreen from "@components/Accesses/MerchOrder/MerchOrderScreen";

export default MerchOrderScreen;
